module.exports = __webpack_public_path__ + "21481f27/img/upload-icon.9179ae4e.svg";